"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseOutboundCostClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const defaultCostOfDelayClientConfig = {
    baseURL: process.env.WAREHOUSE_OUTBOUND_COST_SERVICE_URL,
    basicAuthUser: process.env.WAREHOUSE_OUTBOUND_COST_BASIC_AUTH_USER,
    basicAuthPassword: process.env.WAREHOUSE_OUTBOUND_COST_BASIC_AUTH_PASSWORD,
};
class WarehouseOutboundCostClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = defaultCostOfDelayClientConfig) {
        const { baseURL, basicAuthUser, basicAuthPassword } = config;
        super(config);
        if (!baseURL) {
            commons_logs_1.log.warn("WAREHOUSE_OUTBOUND_COST_SERVICE_URL environment variable is not set");
        }
        if (!basicAuthUser || !basicAuthPassword) {
            commons_logs_1.log.warn("WAREHOUSE_OUTBOUND_COST_BASIC_AUTH_USER and WAREHOUSE_OUTBOUND_COST_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async getWarehouseOutboundCosts(requests) {
        return this.post(`/v1/rates/outbound/`, requests);
    }
}
exports.WarehouseOutboundCostClient = WarehouseOutboundCostClient;
//# sourceMappingURL=WarehouseOutboundCostClient.js.map